export default {
  functionKey: "SPLIT",
  title: "SPLIT",
  group: "Parsing",
  origin: [],
  arguments: [],
  maxArguments: 2,
  showTypeOptions: { origin: false, target: false, arguments: false },
  requiredArguments: [{ argumentKey: "Separator", name: "Séparateur" }],
  expectedArguments: [
    { name: "Séparateur", argumentKey: "Separator", single: true, initialValue: "" },
    { name: "(Optionnel) Intervalle", argumentKey: "Interval", single: true, initialValue: "0" }
  ],
  description: "Créez des nouvelles lignes pour chaque élément séparé par l'argument",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const splitChar = args[0];
    const code = `${destination} = ${origin}.split('${splitChar}');`;
    return { displayCode: code, safeCode: code };
  }
}
